const showDeveloperAPI = process.env.VUE_APP_SHOW_DEVELOPER_API !== 'false'

export { showDeveloperAPI }
